export default __webpack_public_path__ + "static/media/cashback.d01def12.svg";